import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PublicQueryService } from '../../services/public-query.service';
import { Expedition } from '../../interfaces/expedition.interface';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as L from 'leaflet';
import { FaviconService } from '../../services/favicon.service';
import { Title } from '@angular/platform-browser';
import formatDate from '../../utils/formatDate';
import { destination } from '@turf/turf';
import { FileService } from '../../services/file.service';


@Component({
  selector: 'app-cabruca-public-panel',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './cabruca-public-panel.component.html',
  styleUrl: './cabruca-public-panel.component.scss'
})
export class CabrucaPublicPanelComponent implements OnInit, AfterViewInit {
  titleService = inject(Title);
  faviconService = inject(FaviconService);
  publicQueryService = inject(PublicQueryService);
  fileService = inject(FileService);
  formBuilder = inject(FormBuilder);
  activatedRoute = inject(ActivatedRoute);
  public formatDate = formatDate;

  inputCode = '';
  isModalOpen = false;
  currentModal: number | null = null;
  activeUrl = 'cacau';
  loading = false;
  showTraceability = false;
  isMobile = false;
  cabrucaData?: Expedition[];
  form!: FormGroup;
  placeholder = '';
  private map: any;
  identifier = '';
  customer = '';
  product = '';
  origins: any[] = [];
  expandedOrigins: boolean[] = [];
  expandedLastOrigins: boolean[] = [];
  currentIndex = 0;
  productImages: string[] = ['../../../assets/images/safetrace/rastreability-default.png'];
  placesCentroids: L.Marker[] = [];
  lastOriginName = '';

  @ViewChild('mapArea', { static: false }) mapArea!: ElementRef;

  constructor() {
    this.form = this.formBuilder.group({
      code: [''],
    })
  }

  ngOnInit(): void {
    this.titleService.setTitle('Cabruca - Painel Público');
    this.faviconService.changeFavicon('assets/images/cabruca/cabruca-logo.png');
    this.activeUrl = this.activatedRoute.snapshot.url[1].path;

    this.activatedRoute.queryParamMap.subscribe(params => {
      this.identifier = params.get('id')!;
      this.product = params.get('product')!;
      this.customer = params.get('customer')!;
      if (this.identifier) {
        this.form.get('code')?.setValue(this.identifier.trim());
        this.form.get('code')?.disable();
        const payload = {
          identifier: this.identifier,
          customerDocument: this.customer ? this.customer : '',
          productHash: this.product ? this.product : ''
        }
        this.publicQueryService.findAllByIdentificador(payload).subscribe({
          next: (res: Expedition[]) => {
            this.cabrucaData = res;
            this.lastOriginName = this.cabrucaData[0].customerName ? this.cabrucaData[0].customerName : 'Nome não registrado';
            this.addMarkersAndFlow();
            this.filterOrigins();
            this.filterProductImages();
          },
          error: () => {
          },
          complete: () => {
          }
        });
      }
    });

    // this.getTagCode(this.router.url);
    this.getDevice();
    this.disableZoomForMobile();
  }

  ngAfterViewInit(): void {
    this.initMap();
  }

  disableZoomForMobile() {
    document.addEventListener('dblclick', function (event) {
      event.preventDefault();
    });

    document.addEventListener('touchstart', function (event: TouchEvent) {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    }, { passive: false });

    document.addEventListener('touchmove', function (event: TouchEvent) {
      if (event.touches.length > 1) {
        event.preventDefault();
      }
    }, { passive: false });
  }

  getDevice() {
    this.isMobile = window.innerWidth <= 600 ? true : false;
  }

  toggleExpandOrigin(index: number, type: 'lastOrigin' | 'origin'): void {
    if (type === 'origin') {
      this.expandedOrigins[index] = !this.expandedOrigins[index];
    }
    if (type === 'lastOrigin') {
      this.expandedLastOrigins[index] = !this.expandedLastOrigins[index];
    }

  }

  filterOrigins(): void {
    this.cabrucaData!.forEach((invoiceItem: any) => {
      if (!this.origins.some((item: any) => item.productName == invoiceItem.invoiceItem.product.name)) {
        const itemOrigins: any[] = [];
        itemOrigins.push({ customer: invoiceItem.customerName || 'Nome não registrado', provider: invoiceItem.providerName || 'Nome não registrado', date: invoiceItem.movementDate })
        if (invoiceItem.origins.length > 0) {
          invoiceItem.origins.forEach((item: any) => {
            itemOrigins.push({ customer: item.customer.corporateName, provider: item.provider.corporateName, date: item.completionDate });
          });
        }
        this.origins.push({ productName: invoiceItem.invoiceItem.product.name, origins: itemOrigins });

      } else {
        const index: number = this.origins.findIndex((element: any) => element.productName == invoiceItem.invoiceItem.product.name);
        const itemOrigins: any[] = [];
        itemOrigins.push({ customer: invoiceItem.customerName || 'Nome não registrado', provider: invoiceItem.providerName || 'Nome não registrado', date: invoiceItem.movementDate });
        if (invoiceItem.origins.length > 0) {
          invoiceItem.origins.forEach((item: any) => {
            itemOrigins.push({ customer: item.customer.corporateName, provider: item.provider.corporateName, date: item.completionDate });
          });
        }

        itemOrigins.forEach((item: any) => {
          const exists = this.origins[index].origins.some((element: any) => element.customer === item.customer && element.provider === item.provider);
          if (!exists) {
            this.origins[index].origins.push({ customer: item.customer, provider: item.provider, date: item.date });
          }
          else {
            this.origins[index].origins.forEach((origin: any, i: number) => {
              if (this.parseDate(item.date) > this.parseDate(origin.date)) {
                this.origins[index].origins[i] = item;
              }
            })
          }
        });
      }
    })
  }

  async filterProductImages() {
    const imagesBase64: string[] = [];

    this.cabrucaData![0].invoiceItem!.product!.features.forEach((feature: any) => {
      if (feature.type === 'productImage') {
        this.productImages = [];
        imagesBase64.push(feature.value);
      }
    });

    for (const image of imagesBase64) {
      const blob = await this.fileService.downloadPublicFile(image).toPromise();
      if (blob) {
        this.productImages.push(URL.createObjectURL(blob));
      }
    }
  }

  getLastMovement(productName: string, info: 'customer' | 'provider' | 'date'): string {
    const product = this.origins.find((item: any) => item.productName == productName);
    let lastOrigin: any = '';
    product.origins.forEach((element: any) => {
      if (lastOrigin === '') {
        lastOrigin = element;
      } else {
        if (this.parseDate(element.date) > this.parseDate(lastOrigin.date)) {
          lastOrigin = element;
        }
      }
    });
    switch (info) {
      case 'customer':
        return lastOrigin.customer;
      case 'provider':
        return lastOrigin.provider;
      case 'date':
        return lastOrigin.date;
    }
  }

  parseDate(dateStr: string): Date {
    const [year, month, day] = dateStr.split('-').map(Number);
    return new Date(year, month - 1, day);
  }

  // getTagCode(url: string) {
  //   if(url && url.includes('codigoEtiqueta')) {
  //     const urlParams = new URLSearchParams(url.split('?')[1]);
  //     const codigoEtiqueta = urlParams.get('codigoEtiqueta');
  //     this.form.get('code')?.setValue(codigoEtiqueta?.trim());
  //     this.getPublicQuery();
  //   }
  // }

  openModal(modalId: number) {
    this.isModalOpen = true;
    this.currentModal = modalId;
  }

  closeModal() {
    this.isModalOpen = false;
    this.currentModal = null;
    setTimeout(() => {
      this.initMap();
    }, 20)
  }

  nextImage() {
    if (this.productImages.length > 0) {
      this.currentIndex = (this.currentIndex + 1) % this.productImages.length;
    }
  }

  prevImage() {
    if (this.productImages.length > 0) {
      this.currentIndex = (this.currentIndex - 1 + this.productImages.length) % this.productImages.length;
    }
  }

  addMarkersAndFlow(): void {
    if (!this.map) {
      console.error('Mapa não inicializado!');
      return;
    }

    this.placesCentroids.forEach(m => m.remove());
    this.placesCentroids = [];

    const flowCoords: any[] = [];

    // 1) Adiciona marcadores e preenche flowCoords

    this.cabrucaData![0].origins?.forEach((origin: any, index: number) => {
      const provName = origin.provider.corporateName;
      origin.provider.places.forEach((place: any) => {
        const lat = parseFloat(place.latitude);
        const lng = parseFloat(place.longitude);
        try {
          const marker = L.marker([lat, lng], { icon: this.checkOriginType('origin') })
            .addTo(this.map).bindPopup(`<b>ORIGEM:</b> ${provName} - ${place.nickname}`);
          this.placesCentroids.push(marker);
          flowCoords.push([[lat, lng]]);
        } catch {
          console.log(`Erro ao registrar pin de: ${origin.provider.corporateName} para ${origin.customer.corporateName}. Algum deles está sem dados de centróide dos seus locais.`);
        }
      });

      const custName = origin.customer.corporateName;
      origin.customer.places.forEach((place: any) => {
        const lat = parseFloat(place.latitude);
        const lng = parseFloat(place.longitude);
        try {
          const marker = L.marker([lat, lng], { icon: this.checkOriginType('origin') })
            .addTo(this.map).bindPopup(`<b>ORIGEM:</b> ${custName} - ${place.nickname}`);
          this.placesCentroids.push(marker);
          flowCoords[index].push([lat, lng]);
        } catch {
          console.log(`Erro ao registrar pin de: ${origin.customer.corporateName} para ${origin.provider.corporateName}. Algum deles está sem dados de centróide dos seus locais.`);
        }
      });
    });

    if (this.cabrucaData![0].customerCentroid!.latitude && this.cabrucaData![0].customerCentroid!.longitude) {
      const customerName = this.cabrucaData![0].customerName;
      const custLat = parseFloat(this.cabrucaData![0].customerCentroid!.latitude);
      const custLng = parseFloat(this.cabrucaData![0].customerCentroid!.longitude);
      const provLat = parseFloat(this.cabrucaData![0].providerCentroid!.latitude);
      const provLng = parseFloat(this.cabrucaData![0].providerCentroid!.longitude);
      try {
        const customerMarker = L.marker([custLat, custLng], { icon: this.checkOriginType('lastOrigin') }).
          addTo(this.map).bindPopup(`<b>ÚLTIMO DESTINO:</b> ${customerName}`);
        this.placesCentroids.push(customerMarker);
        flowCoords.push([[provLat, provLng], [custLat, custLng]]);
      } catch {
        console.log(`Erro ao registrar pin de: ${customerName}`);
      }
    };

    flowCoords.forEach((pair: any) => {
      const polyline = L.polyline(pair, {
        color: '#ffffff',
        weight: 3,
        opacity: 1,
        dashArray: '5,10'  // opcional: linha tracejada
      }).addTo(this.map);

      // Adiciona setas com o decorator
      try {
        const decorator = (L as any).polylineDecorator(polyline, {
          patterns: [
            {
              offset: '10%',    // começa 10% ao longo da linha
              repeat: '10%',    // repete a cada 10%
              symbol: (L as any).Symbol.arrowHead({
                pixelSize: 8,
                polygon: false,
                pathOptions: { stroke: true, color: 'black', weight: 2 }
              })
            }
          ]
        }).addTo(this.map);
      } catch {
        console.log('Erro ao renderizar setas nas linhas.')
      }
    })
    // Desenha a polyline ligando na ordem
    const firstCentroid = flowCoords[0];
    if (firstCentroid.length > 0) {
      const [lat, lng] = firstCentroid[0] as [number, number];
      this.map.setView([lat, lng], 2);
    }
  }

  checkOriginType(place: string): any {
    switch (place) {
      case ('origin'):
        return this.createPin('Origin');
      case ('lastOrigin'):
        return this.createPin('Distributor');
    }
  }

  createPin(type: string): L.Icon {
    return L.icon({
      iconUrl: `../../../assets/images/cabruca/${type}-Location.svg`,
      iconSize: [45, 61],
      popupAnchor: [0, -50]
    });
  }

  private initMap(): void {
    this.map = L.map(this.mapArea.nativeElement, {
      attributionControl: false,
      minZoom: 2,
      maxBounds: [
        [-180, -180],
        [180, 180]
      ],
      maxBoundsViscosity: 1.0,
      scrollWheelZoom: false
    }).setView([-6.9714, -58.5014], 2);

    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
      attribution: 'Cabruca',
    }).addTo(this.map);

    L.control.attribution({
      position: 'topright'
    }).addTo(this.map);

    L.control.scale({ position: 'topleft' }).addTo(this.map);

    const editableLayers = new L.FeatureGroup();
    this.map.addLayer(editableLayers);
  }
}
